import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <>
      <SEO
        title="Adgang nægtet (403) | Fastlane ApS"
        description="Du har ikke tilladelse til at tilgå denne ressource. Kontakt Fastlane ApS for hjælp."
      />

      <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-lg w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-3xl border border-slate-200 shadow-sm">
          <div className="w-16 h-16 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center mx-auto text-2xl font-bold">
            <i className="fa-solid fa-lock" aria-hidden="true" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-black text-[#0f2b48]">403</h1>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800">
            Adgang nægtet
          </h2>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
            Du har ikke tilladelse til at se denne side eller ressource. Hvis du mener dette er en fejl, er du velkommen til at kontakte os.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#0f2b48] hover:bg-slate-900 text-white font-semibold text-sm transition-colors"
            >
              <i className="fa-solid fa-house mr-2 text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold text-sm transition-colors border border-slate-200"
            >
              <i className="fa-solid fa-envelope mr-2 text-xs" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
